export class Staff {
    userId: number;

    dateAjout: string;
    enabled: boolean;
    fonction: string;
    roleUser: string;
    login: string;
    mail: string;
    mailpass: string;

    mailHassi: string;
    nom: string;
    password: string;
    signerMail: string;
    signerHassi: string;

    projet: string;
    // authoritys: Authority[];
    passHassi: string;
    commercial: boolean;
    archivee: boolean;
    tempstring: string;
    token: string;
    tokenpr: string;

}
export class MailAddress {
    id: number;


    mailAdresse: string;
    signature: string;
    projet: string;



}
export class Authority {

    authorityId: number;


    designation: string;


}
